<template>
  <div>
    <!-- 面包屑导航 -->
    <el-card class="box-card">
      <p>当前操作地址 ： {{ this.myInfo.address }}</p>
      <p>ETH 余额 ：{{ this.myInfo.eth }}</p>

      <div class="refresh">
        <el-button size="small" type="primary" icon="el-icon-refresh " @click="getout">刷新</el-button>
      </div>
    </el-card>

    <!-- 搜索筛选 -->
    <el-form class="user-search">
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="name" label="用户名" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="oldG" label="G币" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="oldH" label="H币" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="oldM" label="M币" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="targetM" label="转移M币">
      </el-table-column>
      <el-table-column align="center" prop="address" label="转移地址">
      </el-table-column>
      <el-table-column align="center" prop="txid" label="Txid" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.txid != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txid" :href="scope.row.url" target="_blank">{{ scope.row.txid.slice(0,6)+'……'+scope.row.txid.substr(scope.row.txid.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 'checking'">
              <el-tag size="medium" type="warning" Plain>等待审核</el-tag>
              <span>操作</span>
              <el-button size="mini" type="success" @click="onAudit(scope.row)">去审核</el-button>
            </div>
            <div v-if="scope.row.status == 'waiting'"><el-tag  type="warning" size="medium" Plain>等待</el-tag></div>
            <div v-if="scope.row.status == 'pending'"><el-tag size="medium" Plain>待检查回执</el-tag></div>
            <div v-if="scope.row.status == 'warn'"><el-tag size="medium" Plain>异常</el-tag></div>
            <div v-if="scope.row.status == 'success'"><el-tag type="success" size="medium" Plain>成功</el-tag></div>
            <div v-if="scope.row.status == 'close'"><el-tag  type="failed" size="medium" Plain>关闭</el-tag></div>
            <div v-if="scope.row.status == 'failed'">
              <el-tag type="danger" size="medium" Plain>失败</el-tag>
              <!-- <div>操作</div> -->
              <el-button size="mini" type="warning" @click="onFailed(scope.row,1)">重试</el-button>
            </div>
            <div v-if="scope.row.status == 'back'"><el-tag size="medium" Plain>退回中</el-tag></div>
            <div v-if="scope.row.status == 'cancel'"><el-tag size="medium">已取消</el-tag></div>
            <div v-if="scope.row.status == 'warning'"><el-tag size="medium">异常</el-tag></div>
          </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="goAudit('reject')">审核拒绝</el-button>
        <el-button type="success" plain @click="goAudit('pass')">审核通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MoveListList , MoveCheck , withdrawBackRetry , MoveUser } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      myInfo:{
        address:'',
        eth:'',
      },
      loading: false, //是显示加载
      centerDialogVisible:false,
      orderId:null,

      formInline: {
        from: 1,
        limit: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getout()
  },
  

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getout(){ 
      this.myInfo = {
        address:'',
        eth:'',
      }
      MoveUser().then(res => {
          // this.loading = false
          if (res && res.code == 0) {
            this.myInfo = res.data
            
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          // this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      MoveListList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 去审核
    onAudit(row){
      this.centerDialogVisible = true
      this.orderId = row.id
    },
    // 去审核
    goAudit(type){
      this.$confirm((type=='pass'?'审核通过':'审核拒绝')+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.myAudit(type)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    //通过和拒绝审核方法
    myAudit(type){
      this.centerDialogVisible = false
      this.loading = true
      let parm = {
        orderId:this.orderId,
        result:type
      };
      MoveCheck(parm)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getdata(this.formInline)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('审核操作失败，请稍后再试！')
        })
    },
    onFailed(row){
      this.orderId = row.id
      this.$confirm('重试, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.myWithdrawBackRetry()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    //重试和退回
    myWithdrawBackRetry(){
      this.loading = true
      let parm = { orderId:this.orderId };
      withdrawBackRetry(parm,'MoveRetry')
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getdata(this.formInline)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
    },
  }
}
</script>

<style scoped>
.pdleft{
  margin-left: 0;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box-card{
  width: 550px;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}
.box-card .refresh{display: flex;justify-content: flex-end;}
.cref{color: red;}
.cyell{color: rgb(247, 196, 14);}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/TransferList.vue